import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./searchBarStyles.js";
import {
  Container,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";

const SearchBar = ({ setSearch, value, children }) => {
  return (
    <Container style={styles.mainContainer}>
      <OutlinedInput
        id="outlined-adornment-search"
        type="text"
        {...(value !== undefined ? { value: value || "" } : {})}
        onChange={(event) => setSearch(event.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        placeholder="Buscar"
        style={styles.searchField}
      />
      {children}
    </Container>
  );
};

export default SearchBar;
